export default "__VITE_ASSET__CVuPfGnd__"